<template>

    <div v-if="isContainer">
        <div class="lg:col-span-1">

            <!-- Master -->
            <div class="px-4 sm:px-0">
                <h2 class="text-lg sm:text-2xl font-medium leading-6 text-gray-800">{{ group.name }}</h2>
                <span class="text-sm text-gray-400" v-html="group.note"></span>

            </div>

        </div>

        <item-form-group
            v-for="group in group.groups"
            :key="group.id"
            :group="group"
            :isSub="isContainer">
        </item-form-group>
    </div>

    <div class="lg:grid lg:grid-cols-3 lg:gap-6 mt-3" v-else>

        <div class="lg:col-span-1">

            <!-- Slave -->
            <div class="px-4 sm:px-0" v-if="isSub">
                <h2 class="text-lg font-medium leading-6 text-gray-600">{{ group.name }}</h2>
                <span class="text-sm text-gray-500" v-html="group.note"></span>
            </div>

            <!-- Master -->
            <div class="px-4 sm:px-0" v-else>
                <h2 class="text-lg sm:text-2xl font-medium leading-6 text-gray-800">{{ group.name }}</h2>
                <span class="text-sm text-gray-600" v-html="group.note"></span>
            </div>

        </div>

        <div class="mt-5 lg:mt-0 lg:col-span-2">
            <div class="shadow border sm:rounded-md sm:overflow-hidden">

                <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                    <item-form-group-parameter
                        v-for="parameter in sortedParameters"
                        :key="parameter.id"
                        :parameter="parameter">
                    </item-form-group-parameter>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

import ItemFormGroupParameter from 'cmp@/ItemFormGroupParameter.vue'
import { sortBy } from 'lodash'

export default {

    name: 'ItemFormGroup',

    components: {
        'item-form-group-parameter': ItemFormGroupParameter,
        'item-form-group': () => import('cmp@/ItemFormGroup'),
    },

    props: {
        group: {
            type: Object,
        },

        isSub: {
            type: Boolean,
        }
    },

    computed: {
        sortedParameters() {
            return sortBy(this.group.parameters, ['priority_id'])
        },

        isContainer() {
            return this.group.hasOwnProperty('groups')
        },
    },

}
</script>
